<gstar-accordion-item
  class="flex-grow-1"
  [hasError]="securityReview().hasErrors()"
  [expanded]="securityReview().isExpanded"
  (expandCollapse)="expandCollapseHandler($event)">
  <div accordion-header>
    <h4 class="mb-1">
      {{ securityReview().security.entity.client.name }}:
      {{ securityReview().security.transactionType.name }} -
      {{ securityReview().security.entity.entityType.name }} -
      {{ securityReview().security.securityType.name }} -
      {{ securityReview().security.investmentJurisdiction.country.name }}
    </h4>
  </div>
  @if (isDetailsRendered()) {
    <gstar-tax-result-security-details [security]="securityReview().security" />
    <div class="pb-4">
      @for (
        review of groupedSecurityReviews();
        track $index;
        let last = $last
      ) {
        @if (!last) {
          <hr />
        }
        @if (review.hasItems()) {
          <gstar-tax-result-fieldset
            [isDisabled]="isReadonly()"
            [transactionType]="
              securityReview().security.transactionType.transactionTypeId
            "
            [securityTaxResultItem]="review"
            [title]="review.title" />
        }
      }
    </div>
    <hr />
    <div class="mt-3 ap-pl-spacing-3 ap-pr-spacing-3 pb-4">
      <h4 class="pb-1 mb-3">
        {{ 'upsertSecurity.comments' | translate }}
      </h4>
      <gstar-comment-field
        [isReadonly]="isReadonly()"
        [securityReview]="securityReview()"
        [textContent]="securityReview().comment()"
        [title]="'upsertSecurity.comments' | translate"
        (update)="updateCommentHandler($event)"></gstar-comment-field>
    </div>

    @if (isAdmin()) {
      <div class="mt-3 ap-pl-spacing-3 ap-pr-spacing-3 pb-4">
        <h4 class="pb-1 mb-3">
          {{ 'upsertSecurity.adminComments' | translate }}
        </h4>
        <gstar-comment-field
          [isReadonly]="isReadonly() || !isAdmin()"
          [securityReview]="securityReview()"
          [title]="getAdminCommentPlaceholder()"
          [textContent]="getAdminCommentText()"
          (update)="updateAdminCommentHandler($event)"></gstar-comment-field>
      </div>
    }
  }
</gstar-accordion-item>
<gstar-action-menu [actionMenu]="actionMenu" [rowData]="securityReview()" />
